export const orderInformations = {
  orderItems: [
    { itemName: "Maior preço", itemValue: "OrderByPriceDESC" },
    { itemName: "Menor preço", itemValue: "OrderByPriceASC" },
    { itemName: "Mais vendidos", itemValue: "OrderByTopSaleDESC" },
    { itemName: "Melhores descontos", itemValue: "OrderByBestDiscountDESC" },
    // { itemName: "Melhores pela marca", itemValue: "OrderByScoreDESC" },
  ],
};

export const filterInformations = {
  sizeItems: [
    {
      vtexName: "lojaanimale",
      size: [
        { filterItemName: "PP", filterItemValue: "PP" },
        { filterItemName: "P", filterItemValue: "P" },
        { filterItemName: "M", filterItemValue: "M" },
        { filterItemName: "G", filterItemValue: "G" },
        { filterItemName: "GG", filterItemValue: "GG" },
        { filterItemName: "U", filterItemValue: "U" },
        { filterItemName: "34", filterItemValue: "34" },
        { filterItemName: "35", filterItemValue: "35" },
        { filterItemName: "36", filterItemValue: "36" },
        { filterItemName: "37", filterItemValue: "37" },
        { filterItemName: "38", filterItemValue: "38" },
        { filterItemName: "39", filterItemValue: "39" },
        { filterItemName: "40", filterItemValue: "40" },
        { filterItemName: "42", filterItemValue: "42" },
        { filterItemName: "44", filterItemValue: "44" },
      ],
    },
    {
      vtexName: "lojafabula",
      size: [
        { filterItemName: "PP", filterItemValue: "PP" },
        { filterItemName: "P", filterItemValue: "P" },
        { filterItemName: "M", filterItemValue: "M" },
        { filterItemName: "G", filterItemValue: "G" },
        { filterItemName: "GG", filterItemValue: "GG" },
        { filterItemName: "02", filterItemValue: "02" },
        { filterItemName: "04", filterItemValue: "04" },
        { filterItemName: "06", filterItemValue: "06" },
        { filterItemName: "08", filterItemValue: "08" },
        { filterItemName: "U", filterItemValue: "U" },
        { filterItemName: "2", filterItemValue: "2" },
        { filterItemName: "4", filterItemValue: "4" },
        { filterItemName: "6", filterItemValue: "6" },
        { filterItemName: "8", filterItemValue: "8" },
        { filterItemName: "10", filterItemValue: "10" },
        { filterItemName: "12", filterItemValue: "12" },
        { filterItemName: "16", filterItemValue: "16" },
        { filterItemName: "17", filterItemValue: "17" },
        { filterItemName: "17 18", filterItemValue: "17 18" },
        { filterItemName: "19", filterItemValue: "19" },
        { filterItemName: "20", filterItemValue: "20" },
        { filterItemName: "21", filterItemValue: "21" },
        { filterItemName: "25", filterItemValue: "25" },
        { filterItemName: "28", filterItemValue: "28" },
        { filterItemName: "29", filterItemValue: "29" },
        { filterItemName: "30", filterItemValue: "30" },
        { filterItemName: "31", filterItemValue: "31" },
        { filterItemName: "32", filterItemValue: "32" },
        { filterItemName: "33", filterItemValue: "33" },
      ],
    },
    {
      vtexName: "lojafarm",
      size: [
        { filterItemName: "PP", filterItemValue: "PP" },
        { filterItemName: "P", filterItemValue: "P" },
        { filterItemName: "M", filterItemValue: "M" },
        { filterItemName: "G", filterItemValue: "G" },
        { filterItemName: "GG", filterItemValue: "GG" },
        { filterItemName: "XGG", filterItemValue: "XGG" },
        { filterItemName: "U", filterItemValue: "U" },
        { filterItemName: "UN", filterItemValue: "UN" },
        { filterItemName: "33", filterItemValue: "33" },
        { filterItemName: "34", filterItemValue: "34" },
        { filterItemName: "35", filterItemValue: "35" },
        { filterItemName: "36", filterItemValue: "36" },
        { filterItemName: "37", filterItemValue: "37" },
        { filterItemName: "38", filterItemValue: "38" },
        { filterItemName: "39", filterItemValue: "39" },
        { filterItemName: "39 40", filterItemValue: "39 40" },
        { filterItemName: "40", filterItemValue: "40" },
        { filterItemName: "41", filterItemValue: "41" },
        { filterItemName: "42", filterItemValue: "42" },
        { filterItemName: "43", filterItemValue: "43" },
        { filterItemName: "44", filterItemValue: "44" },
        { filterItemName: "46", filterItemValue: "46" },
      ],
    },
    {
      vtexName: "lojaoffpremium",
      size: [
        { filterItemName: "PP", filterItemValue: "PP" },
        { filterItemName: "P", filterItemValue: "P" },
        { filterItemName: "M", filterItemValue: "M" },
        { filterItemName: "G", filterItemValue: "G" },
        { filterItemName: "GG", filterItemValue: "GG" },
        { filterItemName: "XGG", filterItemValue: "XGG" },
        { filterItemName: "XXG", filterItemValue: "XXG" },
        { filterItemName: "U", filterItemValue: "U" },
        { filterItemName: "UN", filterItemValue: "UN" },
        { filterItemName: "33", filterItemValue: "33" },
        { filterItemName: "34", filterItemValue: "34" },
        { filterItemName: "35", filterItemValue: "35" },
        { filterItemName: "36", filterItemValue: "36" },
        { filterItemName: "37", filterItemValue: "37" },
        { filterItemName: "38", filterItemValue: "38" },
        { filterItemName: "39", filterItemValue: "39" },
        { filterItemName: "39 40", filterItemValue: "39 40" },
        { filterItemName: "40", filterItemValue: "40" },
        { filterItemName: "41", filterItemValue: "41" },
        { filterItemName: "42", filterItemValue: "42" },
        { filterItemName: "43", filterItemValue: "43" },
        { filterItemName: "44", filterItemValue: "44" },
        { filterItemName: "46", filterItemValue: "46" },
        { filterItemName: "48", filterItemValue: "48" },
      ],
    },
    {
      vtexName: "mariafilo",
      size: [
        { filterItemName: "PP", filterItemValue: "PP" },
        { filterItemName: "P", filterItemValue: "P" },
        { filterItemName: "M", filterItemValue: "M" },
        { filterItemName: "G", filterItemValue: "G" },
        { filterItemName: "GG", filterItemValue: "GG" },
        { filterItemName: "UN", filterItemValue: "UN" },
        { filterItemName: "36", filterItemValue: "36" },
        { filterItemName: "38", filterItemValue: "38" },
        { filterItemName: "40", filterItemValue: "40" },
        { filterItemName: "42", filterItemValue: "42" },
        { filterItemName: "44", filterItemValue: "44" },
      ],
    },
  ],
  colorsItems: [
    {
      vtexName: "lojaanimale",
      colors: [
        { filterItemName: "amarelo", filterItemValue: "amarelo" },
        { filterItemName: "azul", filterItemValue: "azul" },
        { filterItemName: "branco", filterItemValue: "branco" },
        { filterItemName: "cinza", filterItemValue: "cinza" },
        { filterItemName: "estampado", filterItemValue: "estampado" },
        { filterItemName: "dourado", filterItemValue: "dourado" },
        { filterItemName: "laranja", filterItemValue: "laranja" },
        { filterItemName: "marrom", filterItemValue: "marrom" },
        { filterItemName: "nude", filterItemValue: "nude" },
        { filterItemName: "off white", filterItemValue: "off white" },
        { filterItemName: "preto", filterItemValue: "preto" },
        { filterItemName: "rosa", filterItemValue: "rosa" },
        { filterItemName: "roxo", filterItemValue: "roxo" },
        { filterItemName: "verde", filterItemValue: "verde" },
        { filterItemName: "vermelho", filterItemValue: "vermelho" },
      ],
    },
    {
      vtexName: "lojafabula",
      colors: [
        { filterItemName: "amarelo", filterItemValue: "Amarelo" },
        { filterItemName: "azul", filterItemValue: "Azul" },
        { filterItemName: "branco", filterItemValue: "Branco" },
        { filterItemName: "cinza", filterItemValue: "Cinza" },
        { filterItemName: "estampado", filterItemValue: "Estampado" },
        { filterItemName: "laranja", filterItemValue: "Laranja" },
        { filterItemName: "marrom", filterItemValue: "Marrom" },
        { filterItemName: "preto", filterItemValue: "Preto" },
        { filterItemName: "rosa", filterItemValue: "Rosa" },
        { filterItemName: "verde", filterItemValue: "Verde" },
        { filterItemName: "vermelho", filterItemValue: "Vermelho" },
      ],
    },
    {
      vtexName: "lojafarm",
      colors: [
        { filterItemName: "amarelo", filterItemValue: "Amarelo" },
        { filterItemName: "azul", filterItemValue: "Azul" },
        { filterItemName: "bege", filterItemValue: "Bege" },
        { filterItemName: "branco", filterItemValue: "Branco" },
        { filterItemName: "colorido", filterItemValue: "Colorido" },
        { filterItemName: "dourado", filterItemValue: "Dourado" },
        { filterItemName: "laranja", filterItemValue: "Laranja" },
        { filterItemName: "marrom", filterItemValue: "Marrom" },
        { filterItemName: "prata", filterItemValue: "Prata" },
        { filterItemName: "preto", filterItemValue: "Preto" },
        { filterItemName: "rosa", filterItemValue: "Rosa" },
        { filterItemName: "roxo", filterItemValue: "Roxo" },
        { filterItemName: "verde", filterItemValue: "Verde" },
        { filterItemName: "vermelho", filterItemValue: "Vermelho" },
      ],
    },
    {
      vtexName: "lojaoffpremium",
      colors: [
        { filterItemName: "amarelo", filterItemValue: "Amarelo" },
        { filterItemName: "azul", filterItemValue: "Azul" },
        { filterItemName: "bege", filterItemValue: "Bege" },
        { filterItemName: "branco", filterItemValue: "Branco" },
        { filterItemName: "cereja", filterItemValue: "CEREJA" },
        { filterItemName: "estampado", filterItemValue: "Estampado" },
        { filterItemName: "dourado", filterItemValue: "Dourado" },
        { filterItemName: "laranja", filterItemValue: "Laranja" },
        { filterItemName: "marrom", filterItemValue: "Marrom" },
        { filterItemName: "off white", filterItemValue: "Off White" },
        { filterItemName: "prata", filterItemValue: "Prata" },
        { filterItemName: "preto", filterItemValue: "Preto" },
        { filterItemName: "rosa", filterItemValue: "Rosa" },
        { filterItemName: "roxo", filterItemValue: "Roxo" },
        { filterItemName: "verde", filterItemValue: "Verde" },
        { filterItemName: "vermelho", filterItemValue: "Vermelho" },
        { filterItemName: "vinho", filterItemValue: "Vinho" },
      ],
    },
    {
      vtexName: "mariafilo",
      colors: [
        { filterItemName: "amarelo", filterItemValue: "AMARELO" },
        { filterItemName: "azul", filterItemValue: "AZUL" },
        { filterItemName: "bege", filterItemValue: "BEGE" },
        { filterItemName: "branco", filterItemValue: "BRANCO" },
        { filterItemName: "dourado", filterItemValue: "DOURADO" },
        { filterItemName: "laranja", filterItemValue: "LARANJA" },
        { filterItemName: "marinho", filterItemValue: "MARINHO" },
        { filterItemName: "off white", filterItemValue: "OFF WHITE" },
        { filterItemName: "preto", filterItemValue: "PRETO" },
        { filterItemName: "rosa", filterItemValue: "ROSA" },
        { filterItemName: "verde", filterItemValue: "VERDE" },
        { filterItemName: "vermelho", filterItemValue: "VERMELHO" },
        { filterItemName: "vinho", filterItemValue: "VINHO" },
      ],
    },
  ],
};
